import Collapse, { collapseClasses } from "@mui/material/Collapse";
import { styled } from "@mui/material/styles";

export const MainContentDetails = styled("div")(({ theme }) => ({
  gap: "24px",
  display: "flex",
  flexDirection: "column",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },
}));

export const FlexContainer = styled("div")(() => ({
  position: "relative",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  width: "100%",
  flex: 1,
}));

export const FlexContainerLeftSection = styled(FlexContainer)(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    order: 2,
  },
}));

const getPixels = (value: string | number) => (typeof value === "number" ? `${value}px` : value);

type RightSectionProps = {
  height?: string | number;
};
export const FlexContainerRightSection = styled(Collapse, {
  shouldForwardProp: (props) => props !== "height",
})<RightSectionProps>(({ theme, height }) => ({
  height: height ? getPixels(height) : "auto",
  maxHeight: height ? getPixels(height) : "auto",
  width: "50%",

  [theme.breakpoints.down("md")]: {
    order: 1,
    width: "100%",
  },
  [`& .${collapseClasses.wrapperInner}`]: {
    width: "100%",
  },
}));
